webpackJsonp([18],{

/***/ 1537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareMain_vue__ = __webpack_require__(1906);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b61a1c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareMain_vue__ = __webpack_require__(2336);
function injectStyle (ssrContext) {
  __webpack_require__(2334)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoftwareMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b61a1c3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoftwareMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1556);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1558), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
__webpack_require__(1559);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(222);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(446);
var createProperty = __webpack_require__(1560);
var getIterFn = __webpack_require__(962);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BYTES_PER_MB = 1048576;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ProgressBar',
    props: {
        loaded: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    computed: {
        indeterminate: function indeterminate() {
            return !(this.total > 0);
        },
        percent: function percent() {
            if (this.indeterminate) return 0;
            return Math.min(100, this.loaded / this.total * 100);
        },
        label: function label() {
            if (this.indeterminate) {
                // Size unknown: show what we have, or "Preparing" before any bytes.
                return this.loaded > 0 ? this.toMB(this.loaded) + ' MB' : this.$t('Preparing');
            }
            return this.toMB(this.loaded) + ' MB / ' + this.toMB(this.total) + ' MB';
        }
    },
    methods: {
        toMB: function toMB(bytes) {
            return (bytes / BYTES_PER_MB).toFixed(2);
        }
    }
});

/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(451)('meta');
var isObject = __webpack_require__(186);
var has = __webpack_require__(223);
var setDesc = __webpack_require__(184).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(444)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__(1602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__(1666);
function injectStyle (ssrContext) {
  __webpack_require__(1664)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4018aa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4018aa0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseProgress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);

// Cross-browser parsing of axios up/download progress events.
//
// axios 1.x sets `progressEvent.total` to `undefined` whenever the transfer is
// not length-computable. For downloads this happens routinely when the response
// is gzip/br compressed, chunked or streamed – and whether it happens depends on
// the server<->browser content negotiation, which is why the old code worked in
// some browsers/setups but not others.
//
// To behave identically everywhere we recover the total from, in order:
//   1. progressEvent.total          (reliable, only set when length-computable)
//   2. a caller-supplied known size (e.g. the file's real byte size)
//   3. the Content-Length response header read straight off the XHR
// and, when none is available, we report `indeterminate` so the UI can render an
// animated "in progress" bar instead of a stuck/NaN one.

function parseProgress(progressEvent) {
    var fallbackTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var loaded = toPositive(progressEvent && progressEvent.loaded) || 0;

    var total = toPositive(progressEvent && progressEvent.total);

    if (!total) {
        total = toPositive(fallbackTotal);
    }

    if (!total) {
        total = toPositive(contentLength(progressEvent));
    }

    // A total smaller than the bytes already transferred means the header
    // describes the compressed payload while `loaded` counts decompressed
    // bytes – the percentage would be meaningless, so treat it as unknown.
    if (total && loaded > total) {
        total = 0;
    }

    return {
        loaded: loaded,
        total: total,
        indeterminate: !total
    };
}

function contentLength(progressEvent) {
    var xhr = progressEvent && progressEvent.event && progressEvent.event.target;
    if (xhr && typeof xhr.getResponseHeader === 'function') {
        return Number(xhr.getResponseHeader('Content-Length'));
    }
    return 0;
}

function toPositive(value) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) && value > 0 ? value : 0;
}

/***/ }),

/***/ 1612:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1663:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(224);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("74e4044a", content, true, {});

/***/ }),

/***/ 1665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".progress-container[data-v-d4018aa0]{margin:10px 20px}.progress-head[data-v-d4018aa0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;margin-bottom:6px;font-size:14px;color:#414f51}.progress-percent[data-v-d4018aa0]{font-weight:600;color:#356c88}.crfi-progress[data-v-d4018aa0]{position:relative;width:100%;height:12px;border-radius:6px;background-color:#e3ebee;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1);overflow:hidden}.crfi-progress-bar[data-v-d4018aa0]{height:100%;border-radius:6px;background-color:#356c88;-webkit-transition:width .2s linear;transition:width .2s linear}.crfi-progress-bar.indeterminate[data-v-d4018aa0]{position:absolute;left:0;top:0;width:40%;-webkit-animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;animation:crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite}@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}@keyframes crfi-progress-indeterminate-data-v-d4018aa0{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(250%);transform:translateX(250%)}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/ProgressBar.vue"],"names":[],"mappings":"AACA,qCACI,gBAAkB,CACrB,AACD,gCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,mCACI,gBAAiB,AACjB,aAAe,CAClB,AACD,gCACI,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kDAAuD,AAC/C,0CAA+C,AACvD,eAAiB,CACpB,AACD,oCACI,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,oCAAsC,AACtC,2BAA8B,CACjC,AACD,kDACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,UAAW,AACX,wFAAyF,AACjF,+EAAiF,CAC5F,AACD,+DACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA,AACD,uDACA,GAAO,oCAAqC,AAAC,2BAA6B,CACzE,AACD,GAAK,mCAAoC,AAAC,0BAA4B,CACrE,CACA","file":"ProgressBar.vue","sourcesContent":["\n.progress-container[data-v-d4018aa0] {\n    margin: 10px 20px;\n}\n.progress-head[data-v-d4018aa0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: baseline;\n        -ms-flex-align: baseline;\n            align-items: baseline;\n    margin-bottom: 6px;\n    font-size: 14px;\n    color: #414F51;\n}\n.progress-percent[data-v-d4018aa0] {\n    font-weight: 600;\n    color: #356C88;\n}\n.crfi-progress[data-v-d4018aa0] {\n    position: relative;\n    width: 100%;\n    height: 12px;\n    border-radius: 6px;\n    background-color: #e3ebee;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n            box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n.crfi-progress-bar[data-v-d4018aa0] {\n    height: 100%;\n    border-radius: 6px;\n    background-color: #356C88;\n    -webkit-transition: width 0.2s linear;\n    transition: width 0.2s linear;\n}\n.crfi-progress-bar.indeterminate[data-v-d4018aa0] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 40%;\n    -webkit-animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n            animation: crfi-progress-indeterminate-data-v-d4018aa0 1.4s ease-in-out infinite;\n}\n@-webkit-keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n@keyframes crfi-progress-indeterminate-data-v-d4018aa0 {\nfrom { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(250%); transform: translateX(250%);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container vertical"},[_c('div',{staticClass:"progress-head"},[_c('span',{staticClass:"progress-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(!_vm.indeterminate)?_c('span',{staticClass:"progress-percent"},[_vm._v(_vm._s(_vm.percent.toFixed(0))+"%")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"crfi-progress",attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":_vm.indeterminate ? null : _vm.total,"aria-valuenow":_vm.indeterminate ? null : _vm.loaded}},[(_vm.indeterminate)?_c('div',{staticClass:"crfi-progress-bar indeterminate"}):_c('div',{staticClass:"crfi-progress-bar",style:({ width: _vm.percent + '%' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1668), __esModule: true };

/***/ }),

/***/ 1668:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1669);
module.exports = __webpack_require__(105).Number.isFinite;


/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(183);
var _isFinite = __webpack_require__(80).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    emits: ['onChange'],
    props: {
        label: {},
        checkModel: {},
        color: {},
        noMargin: {},
        tooltipText: {},
        noPadding: {},
        checkboxError: {}
    },
    data: function data() {
        return {
            vmodel: null
        };
    },

    watch: {
        checkModel: function checkModel(newValue, oldValue) {
            this.vmodel = newValue;
            if (document.getElementById(this.label) != null) {
                document.getElementById(this.label).checked = newValue;
            }
        }
    },
    methods: {
        changed: function changed() {
            this.$emit('onChange', this.vmodel);
        }
    },
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.vmodel = _this.checkModel;

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ 1688:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1689), __esModule: true };

/***/ }),

/***/ 1689:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(974);
__webpack_require__(960);
__webpack_require__(973);
__webpack_require__(1690);
__webpack_require__(1696);
__webpack_require__(1699);
__webpack_require__(1701);
module.exports = __webpack_require__(105).Set;


/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1691);
var validate = __webpack_require__(1612);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1692)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(184).f;
var create = __webpack_require__(975);
var redefineAll = __webpack_require__(971);
var ctx = __webpack_require__(222);
var anInstance = __webpack_require__(970);
var forOf = __webpack_require__(964);
var $iterDefine = __webpack_require__(452);
var step = __webpack_require__(976);
var setSpecies = __webpack_require__(977);
var DESCRIPTORS = __webpack_require__(154);
var fastKey = __webpack_require__(1603).fastKey;
var validate = __webpack_require__(1612);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(80);
var $export = __webpack_require__(183);
var meta = __webpack_require__(1603);
var fails = __webpack_require__(444);
var hide = __webpack_require__(155);
var redefineAll = __webpack_require__(971);
var forOf = __webpack_require__(964);
var anInstance = __webpack_require__(970);
var isObject = __webpack_require__(186);
var setToStringTag = __webpack_require__(298);
var dP = __webpack_require__(184).f;
var each = __webpack_require__(1693)(0);
var DESCRIPTORS = __webpack_require__(154);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(222);
var IObject = __webpack_require__(968);
var toObject = __webpack_require__(954);
var toLength = __webpack_require__(446);
var asc = __webpack_require__(1694);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1694:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1695);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1695:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(186);
var isArray = __webpack_require__(1663);
var SPECIES = __webpack_require__(87)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(183);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1697)('Set') });


/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(453);
var from = __webpack_require__(1698);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1698:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(964);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1699:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1700)('Set');


/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1701:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1702)('Set');


/***/ }),

/***/ 1702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(183);
var aFunction = __webpack_require__(225);
var ctx = __webpack_require__(222);
var forOf = __webpack_require__(964);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBoxCrfi_vue__ = __webpack_require__(1670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de29f1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBoxCrfi_vue__ = __webpack_require__(1707);
function injectStyle (ssrContext) {
  __webpack_require__(1705)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckBoxCrfi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de29f1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckBoxCrfi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1705:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1706);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1000b0e3", content, true, {});

/***/ }),

/***/ 1706:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".long-cont{min-width:200px;padding:10px;border-radius:5px}.long-cont.no-margin{padding-top:5px;padding-bottom:5px;margin:0;min-width:unset}.long-cont.no-pad{padding-top:5px;padding-bottom:5px;margin:5px}.long-cont-grayed{color:#fff}.long-cb-cont{display:block;position:relative;padding-left:35px;cursor:pointer;font-size:14px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.long-cont>label{margin-bottom:0;line-height:25px}.long-cb-cont input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.long-checkmark{color:#fff;position:absolute;top:0;left:0;height:25px;width:25px;border:1px solid #fff;border-radius:5px;-webkit-box-shadow:inset 0 4px 4px rgba(0,0,0,.25);box-shadow:inset 0 4px 4px rgba(0,0,0,.25)}.long-cb-cont input:checked~.long-checkmark{background-color:#fff}.long-cb-cont:hover input~.long-checkmark{border:1px solid #fff;background-color:hsla(0,0%,100%,.4)}.long-checkmark:after{content:\"\";position:absolute;display:none}.long-cb-cont input:checked~.long-checkmark:after{display:block}.long-cb-cont .long-checkmark:after{left:8px;top:2px;width:7px;height:15px;border:solid #000;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.color-box{border:1px solid #000;border-radius:5px;height:25px;width:25px}.tippy-tooltip.customTheme-theme{background-color:#346f8b;text-align:left;font-size:16px}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}.error{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/CheckBoxCrfi.vue"],"names":[],"mappings":"AACA,WAEI,gBAAiB,AACjB,aAAc,AACd,iBAAmB,CACtB,AACD,qBACI,gBAAiB,AACjB,mBAAoB,AACpB,SAAU,AACV,eAAiB,CACpB,AACD,kBACI,gBAAiB,AACjB,mBAAoB,AACpB,UAAY,CACf,AACD,kBAEI,UAAa,CAChB,AACD,cACI,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACrB,AACD,iBACI,gBAAmB,AACnB,gBAAkB,CACrB,AACD,oBACI,kBAAmB,AACnB,UAAW,AACX,eAAgB,AAChB,SAAU,AACV,OAAS,CACZ,AACD,gBACI,WAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,sBAAwB,AACxB,kBAAmB,AACnB,mDAA0D,AAClD,0CAAkD,CAC7D,AACD,4CACI,qBAAyB,CAC5B,AACD,0CACI,sBAAwB,AACxB,mCAA2C,CAC9C,AACD,sBACI,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACjB,AACD,kDACI,aAAe,CAClB,AACD,oCACI,SAAU,AACV,QAAS,AACT,UAAW,AACX,YAAa,AACb,kBAAoB,AACpB,yBAA0B,AAC1B,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,WACI,sBAAwB,AACxB,kBAAmB,AACnB,YAAa,AACb,UAAY,CACf,AACD,iCACI,yBAA0B,AAC1B,gBAAiB,AACjB,cAAgB,CACnB,AACD,+EACI,6BAA+B,CAClC,AACD,OACQ,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CACnC","file":"CheckBoxCrfi.vue","sourcesContent":["\n.long-cont {\n    /* margin: 10px; */\n    min-width: 200px;\n    padding: 10px;\n    border-radius: 5px;\n}\n.long-cont.no-margin {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin: 0;\n    min-width: unset;\n}\n.long-cont.no-pad{\n    padding-top: 5px;\n    padding-bottom: 5px;\n    margin: 5px;\n}\n.long-cont-grayed {\n    /* background-color: #1988A8; */\n    color: white;\n}\n.long-cb-cont {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    cursor: pointer;\n    font-size: 14px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n.long-cont > label {\n    margin-bottom: 0px;\n    line-height: 25px;\n}\n.long-cb-cont input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n.long-checkmark {\n    color: white;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 25px;\n    width: 25px;\n    border: 1px solid white;\n    border-radius: 5px;\n    -webkit-box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n.long-cb-cont input:checked ~ .long-checkmark {\n    background-color: white ;\n}\n.long-cb-cont:hover input ~ .long-checkmark {\n    border: 1px solid white;\n    background-color: rgba(255, 255, 255, 0.4);\n}\n.long-checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n.long-cb-cont input:checked ~ .long-checkmark:after {\n    display: block;\n}\n.long-cb-cont .long-checkmark:after {\n    left: 8px;\n    top: 2px;\n    width: 7px;\n    height: 15px;\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n.color-box {\n    border: solid 1px black;\n    border-radius: 5px;\n    height: 25px;\n    width: 25px;\n}\n.tippy-tooltip.customTheme-theme {\n    background-color: #346F8B;\n    text-align: left;\n    font-size: 16px;\n}\n.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {\n    border-left: 8px solid #346F8B;\n}\n.error {\n        text-align: left !important;\n        color: #FD8282;\n        font-size: 11px;\n        font-weight: bold;\n        font-family: 'Open Sans', sans-serif !important;\n        font-style: normal !important;\n        font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"align-items":"center"}},[_c('div',{class:{ 'long-cont': true, 'long-cont-grayed': _vm.vmodel, 'no-margin': _vm.noMargin, 'no-pad': _vm.noPadding}},[_c('label',{staticClass:"long-cb-cont mt-4 mb-1",attrs:{"for":_vm.label}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vmodel),expression:"vmodel"}],attrs:{"type":"checkbox","id":_vm.label,"value":"label"},domProps:{"checked":Array.isArray(_vm.vmodel)?_vm._i(_vm.vmodel,"label")>-1:(_vm.vmodel)},on:{"change":[function($event){var $$a=_vm.vmodel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="label",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.vmodel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.vmodel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.vmodel=$$c}},_vm.changed]}}),_vm._v(" "),_c('span',{staticClass:"long-checkmark",style:(_vm.checkboxError.length != 0 ? 'border: 2px solid #FD8282 !important;' : '')}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0px","color":"white"}},[_vm._v(_vm._s(_vm.$t(_vm.label)))])]),_vm._v(" "),(_vm.checkboxError.length != 0)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.checkboxError))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CheckBoxCrfi_vue__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProgressBar_vue__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_progress__ = __webpack_require__(1605);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var context;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Button: __WEBPACK_IMPORTED_MODULE_5__components_Button_vue__["a" /* default */], CheckBoxCrfi: __WEBPACK_IMPORTED_MODULE_6__components_CheckBoxCrfi_vue__["a" /* default */], ProgressBar: __WEBPACK_IMPORTED_MODULE_7__components_ProgressBar_vue__["a" /* default */] },
    data: function data() {
        return {
            platforms: [],
            requirementNames: [],
            requirements: [],
            selectionsRequirements: [],
            // progress
            bytesReceived: 0,
            bytesToReceive: 0
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_51" /* getSoftwarePlatforms */])();

                            case 2:
                                _this.platforms = _context.sent;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_95" /* getVersionsOverview */])();

                            case 5:
                                _this.products = _context.sent;
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_42" /* getRequirementsList */])();

                            case 8:
                                _this.requirements = _context.sent;

                                _this.requirementNames = _this.getNewest(_this.requirements);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        compareVersions: function compareVersions(v1, v2) {
            if (v1 == '' || v1 == null || v2 == '' || v2 == null) {
                return 0;
            }

            var v1Parts = v1.split('.');
            var v2Parts = v2.split('.');

            var len = v1Parts.length() < v2Parts.length() ? v1Parts.length() : v2Parts.length();

            for (var i = 0; i < len; i++) {
                if (v1Parts[i] != v2Parts[i]) {
                    if (v1Parts[i] > v2Parts[i]) {
                        return 1;
                    }
                    return -1;
                }
            }

            return v1Parts.length() > v2Parts.length() ? 1 : -1;
        },
        getNewest: function getNewest(data) {
            return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(data.map(function (item) {
                return item.program;
            }))));
        },
        downloadLatest: function downloadLatest(product) {
            var _this2 = this;

            console.table(this.products);
            var productList = this.products.filter(function (x) {
                return x.platform == product;
            });

            console.table(productList);

            if (productList.length == 0) {
                var x = document.getElementById("snackbar");
                x.className = "show";
                x.innerHTML = this.$i18n.t('NotFound') + ' - ' + product;
                setTimeout(function () {
                    x.className = x.className.replace("show", "");
                }, 3000);
                return;
            }

            if (productList.length > 1) {
                productList = productList.sort(function (a, b) {
                    return _this2.compareVersions(a.softwareVersion, b.softwareVersion);
                });
            }

            var objectToDownload = productList[0];
            this.downloadVersion(objectToDownload.id, objectToDownload.fileName, objectToDownload.fileSize);
        },
        downloadVersion: function downloadVersion(id, fileName) {
            var _this3 = this;

            var knownSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var x, followConfig, blob, a, url;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                x = document.getElementById("progress-snackbar");

                                x.className = "snack show";
                                _this3.bytesReceived = 0;
                                _this3.bytesToReceive = 0;

                                followConfig = {
                                    onDownloadProgress: function onDownloadProgress(progressEvent) {
                                        var _parseProgress = Object(__WEBPACK_IMPORTED_MODULE_8__util_progress__["a" /* parseProgress */])(progressEvent, knownSize),
                                            loaded = _parseProgress.loaded,
                                            total = _parseProgress.total;

                                        context.bytesReceived = loaded;
                                        context.bytesToReceive = total;
                                    }
                                };
                                _context2.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_94" /* getVersionById */])(id, followConfig);

                            case 7:
                                blob = _context2.sent;
                                a = document.createElement("a");

                                document.body.appendChild(a);
                                a.style = "display: none";

                                url = window.URL.createObjectURL(blob.data);

                                a.href = url;
                                a.download = fileName;
                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                setTimeout(function () {
                                    x.className = x.className.replace(" show", "");
                                }, 1000);

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        changeRequirementSelection: function changeRequirementSelection(req) {},
        changePlatform: function changePlatform(platform) {}
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            context = this;

                            this.getData();

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 2334:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2335);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("7741b254", content, true, {});

/***/ }),

/***/ 2335:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".save-button{margin-right:10px}label.mt-4{margin-top:0!important}.selection-section{background-color:#414f51;border:1px solid #fff;border-radius:5px;padding:10px 20px;margin:5px 10px 5px 0}.progress-container{margin:10px 20px}#upload-progress{height:20px;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Software/SoftwareMain.vue"],"names":[],"mappings":"AACA,aACI,iBAAmB,CACtB,AACD,WACI,sBAAyB,CAC5B,AACD,mBACI,yBAA0B,AAC1B,sBAAwB,AACxB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAuB,CAC1B,AACD,oBACI,gBAAkB,CACrB,AACD,iBACI,YAAa,AACb,iBAAmB,CACtB","file":"SoftwareMain.vue","sourcesContent":["\n.save-button {\n    margin-right: 10px;\n}\nlabel.mt-4 {\n    margin-top: 0 !important;\n}\n.selection-section {\n    background-color: #414F51; \n    border: 1px solid white; \n    border-radius: 5px; \n    padding: 10px 20px; \n    margin: 5px 10px 5px 0;\n}\n.progress-container {\n    margin: 10px 20px;\n}\n#upload-progress {\n    height: 20px;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{attrs:{"id":"snackbar"}},[_vm._v(_vm._s(_vm.$t('Copied')))]),_vm._v(" "),_c('div',{staticClass:"snack",attrs:{"id":"progress-snackbar"}},[_c('div',{staticClass:"progress-container vertical",staticStyle:{"min-width":"30vw"}},[_c('ProgressBar',{attrs:{"loaded":_vm.bytesReceived,"total":_vm.bytesToReceive}})],1)]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('CRFIVersions')))]),_vm._v(" "),_c('div',{staticClass:"vertical"},[_c('div',{staticClass:"horizontal"},[_c('div',{staticClass:"selection-section"},[_c('h5',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Platform')))]),_vm._v(" "),_vm._l((_vm.platforms),function(platform){return _c('check-box-crfi',{key:platform,attrs:{"checkbox-error":'',"noMargin":true,"label":platform,"no-margin":true,"no-padding":true},on:{"onChange":function($event){return _vm.changePlatform(platform)}}})})],2),_vm._v(" "),_c('div',{staticClass:"selection-section"},[_c('h5',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('Requirements')))]),_vm._v(" "),_vm._l((_vm.requirementNames),function(req){return _c('check-box-crfi',{key:req,attrs:{"checkbox-error":'',"noMargin":true,"label":req,"no-margin":true,"no-padding":true},on:{"onChange":function($event){return _vm.changeRequirementSelection(req)}}})})],2)]),_vm._v(" "),_c('div',[_c('Button',{attrs:{"buttonClass":"save-button semi-bold w-100","title":_vm.$t('DownloadPack')}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('Components')))]),_vm._v(" "),_c('div',{staticClass:"horizontal"},[_c('Button',{attrs:{"buttonClass":"save-button semi-bold w-100","title":_vm.$t('DownloadWSS')},on:{"onClick":function($event){return _vm.downloadLatest('WSS')}}}),_vm._v(" "),_c('Button',{attrs:{"buttonClass":"save-button semi-bold w-100","title":_vm.$t('DownloadLTC')},on:{"onClick":function($event){return _vm.downloadLatest('LTC')}}}),_vm._v(" "),_c('Button',{attrs:{"buttonClass":"save-button semi-bold w-100","title":_vm.$t('DownloadBlackBox')},on:{"onClick":function($event){return _vm.downloadLatest('BlackBox')}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.e60750fbdd6d3c8aac77.js